import React from 'react';
import { SEO } from '../components/SEO';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowRightIcon, ShieldIcon, ZapIcon, DatabaseIcon, ActivityIcon, CheckCircleIcon, ServerIcon, LockIcon, TrendingUpIcon, RefreshCwIcon, MailIcon, ShoppingCartIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const HostingPage: React.FC = () => {
  const hostingFeatures = [{
    icon: <RefreshCwIcon className="h-6 w-6" data-id="element-1411" />,
    title: 'Managed hosting en updates',
    description: "Wij draaien de updates van WordPress, thema's en plugins op een rustig moment. Jij hoeft niet bang te zijn dat je site er kapot van gaat."
  }, {
    icon: <LockIcon className="h-6 w-6" data-id="element-1412" />,
    title: 'SSL en beveiliging',
    description: 'SSL-certificaat ingeregeld en automatisch verlengd. Actieve beveiliging, malware-detectie en bescherming tegen ongewenste toegang.'
  }, {
    icon: <ZapIcon className="h-6 w-6" data-id="element-1413" />,
    title: 'Snelheid en performance',
    description: 'Caching, image-optimalisatie en een server-stack die je bezoekers niet laat wachten, ook niet op piekmomenten.'
  }, {
    icon: <DatabaseIcon className="h-6 w-6" data-id="element-1414" />,
    title: 'Backups en monitoring',
    description: 'Dagelijkse backups en 24/7 monitoring, zodat problemen vaak al opgelost zijn voordat jij ze opmerkt.'
  }];
  const inclusions = ['Managed WordPress hosting op onze eigen omgeving', 'SSL-certificaat, automatisch verlengd', 'Dagelijkse backups, 14 dagen bewaard', "Wekelijkse updates van WordPress, thema's en plugins", '24/7 monitoring met directe melding bij downtime', 'Anti-spam, antivirus en bot-bescherming', 'Razendsnelle laadtijden met caching en optimalisatie', 'Persoonlijk contact met het team dat je site bouwde'];
  const benefits = [{
    icon: <CheckCircleIcon className="h-6 w-6" data-id="element-1415" />,
    title: 'Hosting voor financieel adviseurs',
    description: 'Speciaal afgestemd op zakelijke dienstverleners die op een veilige en stabiele site moeten kunnen vertrouwen.'
  }, {
    icon: <ServerIcon className="h-6 w-6" data-id="element-1416" />,
    title: 'Webhosting voor administratiekantoren',
    description: 'Betrouwbaar, met garantie op uptime en snelheid, op een omgeving die wij zelf onderhouden.'
  }, {
    icon: <ActivityIcon className="h-6 w-6" data-id="element-1417" />,
    title: 'Hosting op maat voor MKB',
    description: 'Flexibele oplossing die meegroeit met je bedrijf, zonder dat je over moet stappen.'
  }, {
    icon: <TrendingUpIcon className="h-6 w-6" data-id="element-1418" />,
    title: 'Betere afstemming met SEO',
    description: 'Technische SEO-optimalisaties voeren we direct door, zonder discussie met een externe partij.'
  }, {
    icon: <MailIcon className="h-6 w-6" data-id="element-1419" />,
    title: 'Zakelijke e-mail naast je hosting',
    description: 'Combineer je hosting met onze e-mail pakketten (Starter, Premium of Google Workspace) voor één compleet pakket.'
  }];
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-1420">
      <SEO title="Zakelijke hosting voor €34,99 per maand | Noord Digital" description="Managed hosting voor zakelijke websites, vaste prijs van €34,99 per maand. Inclusief SSL, dagelijkse backups, 24/7 monitoring en wekelijkse updates. Geschikt voor financieel adviseurs, administratiekantoren en zakelijke dienstverleners." keywords="managed hosting, zakelijke hosting, hosting financieel adviseur, webhosting administratiekantoor, SSL certificaat, dagelijkse backups, WordPress hosting, hosting MKB" canonical="https://noorddigital.nl/zakelijke-hosting" data-id="element-1421" />
      <Header data-id="element-1422" />

      {/* Hero */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#1B2B44] py-16 md:py-20 relative overflow-hidden" data-id="element-1423">
        <div className="absolute inset-0 opacity-20" data-id="element-1424">
          <div className="w-full h-full bg-[url('https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center" data-id="element-1425"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10" data-id="element-1426">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-1427">
            <div className="lg:col-span-7" data-id="element-1428">
              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6
            }} className="font-bold text-white leading-tight mb-6 text-4xl md:text-5xl lg:text-6xl" data-id="element-1429">
                Managed hosting voor zakelijke websites, €34,99 per maand
              </motion.h1>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} className="text-white text-opacity-90 mb-8 text-lg leading-relaxed" data-id="element-1430">
                Eén vaste prijs, geen verrassingen achteraf. Wij hosten je website op onze eigen omgeving, regelen SSL, backups, monitoring en updates, en zijn bereikbaar als er iets is. Geschikt voor financieel adviseurs, administratiekantoren en andere zakelijke dienstverleners.
              </motion.p>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="flex flex-wrap gap-4" data-id="element-1431">
                <motion.a href="#hosting-prijs" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-lg group" data-id="element-1432">
                  Bekijk wat erbij zit
                  <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1433" />
                </motion.a>
                <motion.a href="/websites" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-flex items-center px-6 py-3 bg-transparent border-2 border-white text-white font-semibold rounded-lg group" data-id="element-1434">
                  Website laten maken
                  <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1435" />
                </motion.a>
              </motion.div>
            </div>

            {/* Prijs-card */}
            <div className="lg:col-span-5" data-id="element-1436">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="bg-white rounded-2xl p-8 shadow-2xl relative" data-id="element-1437">
                <div className="absolute -top-4 left-6 inline-flex items-center gap-2 bg-[#007AFF] text-white text-xs font-semibold uppercase tracking-wide px-3 py-1.5 rounded-full shadow-md" data-id="element-1438">
                  <ShieldIcon className="h-3 w-3" data-id="element-1439" />
                  Vaste prijs, alles inbegrepen
                </div>
                <div className="text-center mb-6" data-id="element-1440">
                  <p className="text-[#6B7280] text-sm uppercase tracking-wide mb-2" data-id="element-1441">
                    Vanaf
                  </p>
                  <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-1442">
                    <span className="text-6xl md:text-7xl font-bold text-[#111827]" data-id="element-1443">
                      €34,99
                    </span>
                  </div>
                  <p className="text-[#6B7280] text-sm" data-id="element-1444">per maand, excl. BTW</p>
                </div>

                <div className="space-y-3 pt-6 border-t border-gray-200 mb-6" data-id="element-1445">
                  <div className="flex items-center gap-3" data-id="element-1446">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1447" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1448">
                      SSL-certificaat en wekelijkse updates inbegrepen
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1449">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1450" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1451">
                      Dagelijkse backups en 24/7 monitoring
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1452">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1453" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1454">
                      99,9 procent uptime garantie
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1455">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1456" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1457">
                      Persoonlijk contact, geen ticketsysteem
                    </span>
                  </div>
                </div>

                <a href="/contact" className="inline-flex items-center justify-center w-full bg-[#007AFF] text-white font-semibold py-3 px-6 rounded-lg shadow-md" data-id="element-1458">
                  Vraag hosting aan
                  <ArrowRightIcon className="h-5 w-5 ml-2" data-id="element-1459" />
                </a>
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      {/* Wat zit er inbegrepen */}
      <div id="hosting-prijs" className="w-full bg-white py-20 md:py-24" data-id="element-1460">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1461">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1462">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1463">
              Wat zit er bij die €34,99 per maand?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-1464">
              Geen onderdelen die later los gefactureerd worden. Alles wat een zakelijke website nodig heeft om veilig en snel te blijven, zit erin.
            </motion.p>
          </div>

          <div className="max-w-4xl mx-auto bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] rounded-2xl p-8 md:p-12 mb-12" data-id="element-1465">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1466">
              {inclusions.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-1467">
                  <CheckCircleIcon className="h-5 w-5 text-[#007AFF] mt-0.5 flex-shrink-0" data-id="element-1468" />
                  <span className="text-[#6B7280] leading-relaxed" data-id="element-1469">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1470">
            {hostingFeatures.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
          }} className="bg-[#F7F8FA] rounded-2xl p-8 transition-all duration-300 group" data-id="element-1471">
                <div className="flex items-start gap-4" data-id="element-1472">
                  <motion.div whileHover={{
                scale: 1.1,
                rotate: 5
              }} className="flex-shrink-0 w-12 h-12 bg-[#007AFF] rounded-full flex items-center justify-center text-white" data-id="element-1473">
                    {feature.icon}
                  </motion.div>
                  <div className="flex-1" data-id="element-1474">
                    <h3 className="font-bold text-[#111827] text-xl mb-2" data-id="element-1475">
                      {feature.title}
                    </h3>
                    <p className="text-[#6B7280] leading-relaxed" data-id="element-1476">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>

      {/* Waarom hosting bij Noord Digital */}
      <div className="w-full bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] py-20 md:py-24" data-id="element-1477">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1478">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1479">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1480">
              Waarom hosting bij Noord Digital?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-1481">
              Bij veel hostingpartijen ben je een nummer. Bij ons krijg je persoonlijke aandacht, proactief onderhoud en een team dat je website kent. Hosting, website en SEO onder één dak betekent snellere doorvoering en betere resultaten.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1482">
            {[{
            stat: '99,9%',
            label: 'Uptime garantie',
            description: 'Je website is altijd bereikbaar voor je klanten. Mocht er toch iets misgaan, dan zijn wij er direct bij.'
          }, {
            stat: '< 1s',
            label: 'Gemiddelde laadtijd',
            description: 'Snelle websites ranken beter in Google en zorgen voor een betere gebruikerservaring.'
          }, {
            stat: '24/7',
            label: 'Monitoring en support',
            description: 'We houden je website dag en nacht in de gaten. Problemen worden vaak opgelost voordat je ze merkt.'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="bg-white rounded-2xl p-8 shadow-lg text-center" data-id="element-1483">
                <div className="text-4xl md:text-5xl font-bold text-[#007AFF] mb-2" data-id="element-1484">
                  {item.stat}
                </div>
                <div className="text-lg font-bold text-[#111827] mb-3" data-id="element-1485">
                  {item.label}
                </div>
                <p className="text-[#6B7280] leading-relaxed text-sm" data-id="element-1486">
                  {item.description}
                </p>
              </motion.div>)}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8" data-id="element-1487">
            {[{
            title: 'Alles onder één dak',
            description: 'Website, hosting, SEO en e-mail bij één partij. Snellere communicatie, betere afstemming, geen gedoe met verschillende leveranciers.'
          }, {
            title: 'Proactief onderhoud',
            description: 'We wachten niet tot er iets misgaat. Updates, beveiligingspatches en optimalisaties worden automatisch en regelmatig uitgevoerd.'
          }, {
            title: 'Schaalbaar wanneer je groeit',
            description: 'Van een eenvoudige website tot een uitgebreide webshop, onze hosting groeit mee zonder dat je hoeft te migreren.'
          }, {
            title: 'Persoonlijk contact',
            description: 'Geen ticketsystemen of chatbots. Je hebt direct contact met het team dat je website heeft gebouwd en beheert.'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-xl p-6 flex items-start gap-4 shadow-sm border border-gray-100" data-id="element-1488">
                <div className="w-8 h-8 bg-[#007AFF] bg-opacity-10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1489">
                  <CheckCircleIcon className="h-5 w-5 text-[#007AFF]" data-id="element-1490" />
                </div>
                <div data-id="element-1491">
                  <h3 className="font-bold text-[#111827] text-lg mb-1" data-id="element-1492">
                    {item.title}
                  </h3>
                  <p className="text-[#6B7280] text-sm leading-relaxed" data-id="element-1493">
                    {item.description}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="text-center mt-12" data-id="element-1494">
            <p className="text-[#6B7280] mb-4" data-id="element-1495">
              Benieuwd wat hosting bij Noord Digital voor jouw website kan betekenen?
            </p>
            <motion.a href="/contact" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex items-center bg-[#007AFF] text-white font-semibold py-3 px-8 rounded-lg shadow-md group" data-id="element-1496">
              Vraag een vrijblijvend gesprek aan
              <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1497" />
            </motion.a>
          </motion.div>
        </div>
      </div>

      {/* Norden SSL */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-1498">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1499">
          <div className="max-w-4xl mx-auto" data-id="element-1500">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-[#007AFF] to-[#005FCC] rounded-2xl p-8 md:p-12 text-white shadow-xl" data-id="element-1501">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1502">
                <div className="text-center md:text-left" data-id="element-1503">
                  <div className="inline-block relative" data-id="element-1504">
                    <motion.div initial={{
                    opacity: 0,
                    scale: 0.8
                  }} whileInView={{
                    opacity: 1,
                    scale: 1
                  }} viewport={{
                    once: true
                  }} transition={{
                    type: 'spring',
                    stiffness: 100
                  }} className="w-40 h-40 bg-white bg-opacity-20 rounded-full flex items-center justify-center p-4 relative overflow-hidden backdrop-blur-sm" data-id="element-1505">
                      <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden regelt SSL certificaat en updates" className="w-full h-full object-cover" data-id="element-1506" />
                    </motion.div>
                    <motion.div animate={{
                    y: [0, -5, 0],
                    rotate: [0, 5, 0]
                  }} transition={{
                    duration: 3,
                    repeat: Infinity
                  }} className="absolute -top-2 -right-2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg" data-id="element-1507">
                      <LockIcon className="h-6 w-6 text-[#007AFF]" data-id="element-1508" />
                    </motion.div>
                    <motion.div animate={{
                    y: [0, -5, 0],
                    rotate: [0, -360]
                  }} transition={{
                    y: {
                      duration: 4,
                      repeat: Infinity
                    },
                    rotate: {
                      duration: 10,
                      repeat: Infinity,
                      ease: 'linear'
                    }
                  }} className="absolute -bottom-2 -left-2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg" data-id="element-1509">
                      <RefreshCwIcon className="h-6 w-6 text-[#007AFF]" data-id="element-1510" />
                    </motion.div>
                  </div>
                </div>
                <div data-id="element-1511">
                  <motion.h2 initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} className="font-bold text-white text-3xl mb-4" data-id="element-1512">
                    Norden regelt je SSL en je updates
                  </motion.h2>
                  <motion.p initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 0.1
                }} className="text-white text-opacity-90 text-lg leading-relaxed mb-6" data-id="element-1513">
                    Geen gedoe met technische zaken. Norden zorgt automatisch voor je SSL-certificaat, draait updates op een rustig moment en houdt alles veilig. Jij focust op je klanten.
                  </motion.p>
                  <div className="space-y-3" data-id="element-1514">
                    <div className="flex items-center gap-3" data-id="element-1515">
                      <CheckCircleIcon className="h-5 w-5 text-white flex-shrink-0" data-id="element-1516" />
                      <span className="text-white text-opacity-90" data-id="element-1517">
                        Automatische SSL-installatie en verlenging
                      </span>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-1518">
                      <CheckCircleIcon className="h-5 w-5 text-white flex-shrink-0" data-id="element-1519" />
                      <span className="text-white text-opacity-90" data-id="element-1520">
                        Wekelijkse updates van WordPress en plugins
                      </span>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-1521">
                      <CheckCircleIcon className="h-5 w-5 text-white flex-shrink-0" data-id="element-1522" />
                      <span className="text-white text-opacity-90" data-id="element-1523">
                        Proactieve beveiligingscontroles
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Voor wie + cross-sell */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-1524">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1525">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1526">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1527">
              Voor wie werkt deze hosting goed?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed mb-8" data-id="element-1528">
              Naast standaard webhosting hebben we ook ervaring met webshops, WooCommerce en maatwerk-applicaties. Ons hostingpakket groeit mee.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex items-center justify-center gap-3 mb-8" data-id="element-1529">
              <ShoppingCartIcon className="h-8 w-8 text-[#007AFF]" data-id="element-1530" />
              <span className="text-[#6B7280] font-medium" data-id="element-1531">
                Geschikt voor WooCommerce en maatwerk
              </span>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1532">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
          }} className="bg-[#F7F8FA] rounded-2xl p-6 transition-all duration-300 group" data-id="element-1533">
                <motion.div whileHover={{
              scale: 1.1,
              rotate: 5
            }} className="w-12 h-12 bg-[#007AFF] bg-opacity-10 rounded-full flex items-center justify-center text-[#007AFF] mb-4" data-id="element-1534">
                  {benefit.icon}
                </motion.div>
                <h3 className="font-bold text-[#111827] text-lg mb-2" data-id="element-1535">
                  {benefit.title}
                </h3>
                <p className="text-[#6B7280] leading-relaxed" data-id="element-1536">
                  {benefit.description}
                </p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] rounded-2xl p-8 max-w-3xl mx-auto mt-12" data-id="element-1537">
            <h3 className="font-bold text-[#111827] text-xl mb-4 text-center" data-id="element-1538">
              Compleet pakket bij één partij
            </h3>
            <p className="text-[#6B7280] text-center mb-6" data-id="element-1539">
              Combineer je hosting met onze andere diensten voor een professionele online aanwezigheid.
            </p>
            <div className="flex flex-wrap gap-4 justify-center" data-id="element-1540">
              <motion.a href="/websites" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-sm group" data-id="element-1541">
                Onepager vanaf €499
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1542" />
              </motion.a>
              <motion.a href="/email" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-sm group" data-id="element-1543">
                Zakelijke e-mail vanaf €1,99
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1544" />
              </motion.a>
              <motion.a href="/seo" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-sm group" data-id="element-1545">
                SEO optimalisatie
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1546" />
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* CTA */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#005FCC] py-20 md:py-24" data-id="element-1547">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1548">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1549">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-white text-3xl md:text-4xl mb-6" data-id="element-1550">
              Eerlijk geprijsd, alles inbegrepen
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-white text-opacity-90 text-lg leading-relaxed mb-8" data-id="element-1551">
              €34,99 per maand, geen verrassingen, geen losse posten voor SSL of backups. Wij hosten je website op onze eigen omgeving, jij hebt er geen omkijken naar.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="flex flex-wrap gap-4 justify-center" data-id="element-1552">
              <motion.a href="/contact" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-8 py-4 bg-white text-[#007AFF] font-semibold rounded-lg shadow-lg group" data-id="element-1553">
                Neem contact op
                <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1554" />
              </motion.a>
              <motion.a href="/websites" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-lg group" data-id="element-1555">
                Website laten maken
                <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1556" />
              </motion.a>
            </motion.div>
          </div>
        </div>
      </div>

      <Footer data-id="element-1557" />
    </div>;
};